// extracted by mini-css-extract-plugin
export default {"container":"pA-z"};